import axios from 'axios'
import { showSnackbar, snackbarTypes } from 'src/redux/snackbar'

export const JOB_CSV_LOADING = 'csv/JOB_CSV_LOADING'
export const JOB_CSV_SUCCESS = 'csv/JOB_CSV_SUCCESS'
export const JOB_CSV_FAILURE = 'csv/JOB_CSV_FAILURE'

export const jobCsvLoading = () => ({ type: JOB_CSV_LOADING })
export const jobCsvSuccess = () => ({ type: JOB_CSV_SUCCESS })
export const jobCsvFailure = () => ({ type: JOB_CSV_FAILURE })

export const fetchPostJobCSV = file => {
  return async dispatch => {
    dispatch(jobCsvLoading())
    try {
      const formData = new FormData()
      formData.append('file', file)

      await axios({
        url: '/api/jobs/csv-import',
        method: 'POST',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      dispatch(showSnackbar('CSV uploaded. Import is processing.', snackbarTypes.SUCCESS))
      dispatch(jobCsvSuccess())
      return {}
    } catch (error) {
      dispatch(showSnackbar('Upload was not successful.', snackbarTypes.ERROR))
      dispatch(jobCsvFailure())
      const message = error.response?.data?.message || 'Unknown error occurred.'
      return { error: message }
    }
  }
}

const initialState = {
  loading: false,
}

export const csvReducer = (state = initialState, action) => {
  switch (action.type) {
    case JOB_CSV_LOADING:
      return {
        ...state,
        loading: true,
      }
    case JOB_CSV_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case JOB_CSV_FAILURE:
      return {
        ...initialState,
      }
    default:
      return {
        ...state,
      }
  }
}
